import { useMyLessonHomeworkQuery } from 'core/graphql';

import { transformMyLessonHomework } from './transform';
import type { IMyLessonHomework } from './transform';

interface IUseMyLessonHomework {
  /** null = the lesson has no assignment (or it is not visible to the student). */
  homework: IMyLessonHomework | null;
  loading: boolean;
  error: string;
}

/**
 * Student view: assignment + own submission. cache-and-network so a revisit
 * shows the cached state instantly while re-checking the grade/comment on the
 * server. After submitHomework the mutation refetches this operation by name.
 */
export const useMyLessonHomework = (lessonId: string): IUseMyLessonHomework => {
  const { data, loading, error } = useMyLessonHomeworkQuery({
    variables: { lessonId },
    skip: !lessonId,
    fetchPolicy: 'cache-and-network',
  });

  return {
    homework: transformMyLessonHomework(data),
    loading: loading && !data,
    error: error?.message || '',
  };
};
